import AxiosRequest from 'shared/api/util/axiosRequest';

export default new AxiosRequest({
  baseURL: CONFIG.API_ROOT,
});
